// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__M9Q9s.styles_ocean-50__RiIQM {
  color: #e6f2ff;
}

.styles_color__M9Q9s.styles_ocean-100__eknm1 {
  color: #e6f2ff;
}

.styles_color__M9Q9s.styles_ocean-200__vGPYS {
  color: #b3daff;
}

.styles_color__M9Q9s.styles_ocean-300__SFWns {
  color: #7abfff;
}

.styles_color__M9Q9s.styles_ocean-400__Qr2l3 {
  color: #2392fb;
}

.styles_color__M9Q9s.styles_ocean-500__Pl73U {
  color: #0074e0;
}

.styles_color__M9Q9s.styles_ocean-600__OtJBW {
  color: #043571;
}

.styles_color__M9Q9s.styles_space-50__IIlfv {
  color: #f0f0f0;
}

.styles_color__M9Q9s.styles_space-100__rfQoI {
  color: #e3e3e3;
}

.styles_color__M9Q9s.styles_space-200__FkpLX {
  color: #bfbfbf;
}

.styles_color__M9Q9s.styles_space-300__Qqo6G {
  color: gray;
}

.styles_color__M9Q9s.styles_space-400__zojBB {
  color: #616161;
}

.styles_color__M9Q9s.styles_space-500__VDw1- {
  color: #283439;
}

.styles_color__M9Q9s.styles_gray-50__IULPC {
  color: #eff3f6;
}

.styles_color__M9Q9s.styles_gray-100__VBUVq {
  color: #e6ecef;
}

.styles_color__M9Q9s.styles_gray-200__bvIUc {
  color: #cfd8de;
}

.styles_color__M9Q9s.styles_gray-300__ox17c {
  color: #a8b9c2;
}

.styles_color__M9Q9s.styles_gray-400__goRZ4 {
  color: #7e98a5;
}

.styles_color__M9Q9s.styles_gray-500__FRuNY {
  color: #738f9c;
}

.styles_color__M9Q9s.styles_green-50__wuF9K {
  color: #e3fdf6;
}

.styles_color__M9Q9s.styles_green-100__AC1vU {
  color: #c5f6ea;
}

.styles_color__M9Q9s.styles_green-200__JT64S {
  color: #69ddc2;
}

.styles_color__M9Q9s.styles_green-300__FrlAO {
  color: #45bfa3;
}

.styles_color__M9Q9s.styles_green-400__Dpccv {
  color: #1cab8a;
}

.styles_color__M9Q9s.styles_green-500__hc1o2 {
  color: #128268;
}

.styles_color__M9Q9s.styles_red-50__R5hh6 {
  color: #fff0f3;
}

.styles_color__M9Q9s.styles_red-100__Ahrgo {
  color: #f9d2db;
}

.styles_color__M9Q9s.styles_red-200__ny4hS {
  color: #f8b4c4;
}

.styles_color__M9Q9s.styles_red-300__C-R35 {
  color: #e85e81;
}

.styles_color__M9Q9s.styles_red-400__hb2MM {
  color: #e23661;
}

.styles_color__M9Q9s.styles_red-500__Y7t\\+w {
  color: #b82348;
}

.styles_color__M9Q9s.styles_yellow-50__YvupQ {
  color: #fffae6;
}

.styles_color__M9Q9s.styles_yellow-100__4htRX {
  color: #fff0b3;
}

.styles_color__M9Q9s.styles_yellow-200__NuhoI {
  color: #ffe380;
}

.styles_color__M9Q9s.styles_yellow-300__ME-ll {
  color: #ffcf57;
}

.styles_color__M9Q9s.styles_yellow-400__6nqup {
  color: #ffc60a;
}

.styles_color__M9Q9s.styles_yellow-500__rc\\+8H {
  color: #ffb700;
}

.styles_color__M9Q9s.styles_orange-50__0\\+vKy {
  color: #fff2eb;
}

.styles_color__M9Q9s.styles_orange-100__VAl3D {
  color: #ffe4d6;
}

.styles_color__M9Q9s.styles_orange-200__OO39N {
  color: #ffc69e;
}

.styles_color__M9Q9s.styles_orange-300__Zk4V6 {
  color: #ffa047;
}

.styles_color__M9Q9s.styles_orange-400__RSDi5 {
  color: #ff7b42;
}

.styles_color__M9Q9s.styles_orange-500__UFXJh {
  color: #ee4920;
}

.styles_color__M9Q9s.styles_turquoise-50__PDtAv {
  color: transparent;
}

.styles_color__M9Q9s.styles_turquoise-100__nAM0V {
  color: #e6fcff;
}

.styles_color__M9Q9s.styles_turquoise-200__NpOqC {
  color: #b3f5ff;
}

.styles_color__M9Q9s.styles_turquoise-300__YuqYs {
  color: #78e2f2;
}

.styles_color__M9Q9s.styles_turquoise-400__vedAS {
  color: #00c7e6;
}

.styles_color__M9Q9s.styles_turquoise-500__\\+Zaob {
  color: transparent;
}

.styles_color__M9Q9s.styles_turquoise-600__aeLuI {
  color: transparent;
}

.styles_color__M9Q9s.styles_violet-50__7WaOX {
  color: #eae6ff;
}

.styles_color__M9Q9s.styles_violet-100__FvAvU {
  color: #d9d1ff;
}

.styles_color__M9Q9s.styles_violet-200__3czXB {
  color: #bfb3ff;
}

.styles_color__M9Q9s.styles_violet-300__WyZKx {
  color: #9d90ea;
}

.styles_color__M9Q9s.styles_violet-400__kvaSe {
  color: #8678d9;
}

.styles_color__M9Q9s.styles_violet-500__inRME {
  color: #6f5ccc;
}

.styles_color__M9Q9s.styles_snow-50__V8U6P {
  color: white;
}

.styles_color__M9Q9s.styles_snow-100__6yGx\\+ {
  color: #f7f7f7;
}

.styles_color__M9Q9s.styles_snow-200__k5yzZ {
  color: #f0efef;
}

.styles_color__M9Q9s.styles_snow-300__FO\\+w0 {
  color: #e6e6e6;
}

.styles_color__M9Q9s.styles_snow-400__0wG-2 {
  color: #e1e0e0;
}

.styles_color__M9Q9s.styles_snow-500__xJ2SW {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__2Wpg8.styles_ocean__mbn5t {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__2Wpg8.styles_ocean-light__GEXxl {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__2Wpg8.styles_green__2vqsm {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__2Wpg8.styles_green-light__q-PH- {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__2Wpg8.styles_red__yarrS {
  background-color: #e23661;
  color: white;
}

.styles_background-color__2Wpg8.styles_red-light__-0sva {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__2Wpg8.styles_orange__dhVVm {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__2Wpg8.styles_orange-light__6WwNY {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__2Wpg8.styles_space__Of7Am {
  background-color: #616161;
  color: white;
}

.styles_background-color__2Wpg8.styles_space-light__Z2btQ {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__2Wpg8.styles_gray-light__cjMSv {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__2Wpg8.styles_violet__keC1U {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__2Wpg8.styles_violet-light__pXJDN {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__2Wpg8.styles_yellow__R9Jgr {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__2Wpg8.styles_yellow-light__JrR13 {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__DhE8V {
  background-color: white;
  padding: 8px ;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg {
  margin: 4px 0px ;
  max-width: 100%;
  padding: 8px 8px ;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg.styles_current__-fDkU {
  background-color: #f7f7f7;
  border-radius: 5px;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_roomAvatarWrapper__0PB3p {
  margin-right: 8px ;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_roomTitle__PZb9O {
  color: #283439;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_roomLastMessage__GOcbg {
  color: #283439;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_roomMetadataWrapper__EktY7 {
  align-items: flex-end;
  color: #616161;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0px 10px ;
  min-height: 57.6px;
  overflow: hidden;
  padding-top: 4px ;
  text-align: right;
  width: 80px;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_unreadMessagesCount__LNPzI {
  top: -8px;
}
.styles_root__DhE8V .styles_roomWrapper__wCPLg .styles_groupRoomIcon__jRj\\+1 {
  margin-right: 8px ;
}
.styles_root__DhE8V .styles_fab__PHhYj {
  bottom: 24px ;
  position: absolute;
  right: 24px ;
}
.styles_root__DhE8V .styles_fabArrow__T3B9j {
  bottom: 64px ;
  position: absolute;
  right: 48px ;
  width: 35px;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/sidebar/rooms-list/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uBAAA;EACA,aAAA;AA0UJ;AAxUI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AA0UR;AAxUQ;EACI,yBAAA;EACA,kBAAA;AA0UZ;AAvUQ;EACI,kBAAA;AAyUZ;AAtUQ;EACI,cAAA;AAwUZ;AArUQ;EACI,cAAA;AAuUZ;AApUQ;EACI,qBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAsUZ;AAnUQ;EACI,SAAA;AAqUZ;AAlUQ;EACI,kBAAA;AAoUZ;AAhUI;EACI,aAAA;EACA,kBAAA;EACA,YAAA;AAkUR;AA/TI;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAiUR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    background-color: theme.color(snow-50);\n    padding: theme.spacing(1);\n\n    .roomWrapper {\n        margin: theme.spacing(0.5, 0);\n        max-width: 100%;\n        padding: theme.spacing(1, 1);\n\n        &.current {\n            background-color: theme.color(snow-100);\n            border-radius: theme.get-border-radius(md);\n        }\n\n        .roomAvatarWrapper {\n            margin-right: theme.spacing(1);\n        }\n\n        .roomTitle {\n            color: theme.color(space-500);\n        }\n\n        .roomLastMessage {\n            color: theme.color(space-500);\n        }\n\n        .roomMetadataWrapper {\n            align-items: flex-end;\n            color: theme.color(space-400);\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            margin: theme.spacing(0, 1.25);\n            min-height: 57.6px;\n            overflow: hidden;\n            padding-top: theme.spacing(0.5);\n            text-align: right;\n            width: 80px;\n        }\n\n        .unreadMessagesCount {\n            top: -8px;\n        }\n\n        .groupRoomIcon {\n            margin-right: theme.spacing(1);\n        }\n    }\n\n    .fab {\n        bottom: theme.spacing(3);\n        position: absolute;\n        right: theme.spacing(3);\n    }\n\n    .fabArrow {\n        bottom: theme.spacing(8);\n        position: absolute;\n        right: theme.spacing(6);\n        width: 35px;\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__M9Q9s`,
	"ocean-50": `styles_ocean-50__RiIQM`,
	"ocean-100": `styles_ocean-100__eknm1`,
	"ocean-200": `styles_ocean-200__vGPYS`,
	"ocean-300": `styles_ocean-300__SFWns`,
	"ocean-400": `styles_ocean-400__Qr2l3`,
	"ocean-500": `styles_ocean-500__Pl73U`,
	"ocean-600": `styles_ocean-600__OtJBW`,
	"space-50": `styles_space-50__IIlfv`,
	"space-100": `styles_space-100__rfQoI`,
	"space-200": `styles_space-200__FkpLX`,
	"space-300": `styles_space-300__Qqo6G`,
	"space-400": `styles_space-400__zojBB`,
	"space-500": `styles_space-500__VDw1-`,
	"gray-50": `styles_gray-50__IULPC`,
	"gray-100": `styles_gray-100__VBUVq`,
	"gray-200": `styles_gray-200__bvIUc`,
	"gray-300": `styles_gray-300__ox17c`,
	"gray-400": `styles_gray-400__goRZ4`,
	"gray-500": `styles_gray-500__FRuNY`,
	"green-50": `styles_green-50__wuF9K`,
	"green-100": `styles_green-100__AC1vU`,
	"green-200": `styles_green-200__JT64S`,
	"green-300": `styles_green-300__FrlAO`,
	"green-400": `styles_green-400__Dpccv`,
	"green-500": `styles_green-500__hc1o2`,
	"red-50": `styles_red-50__R5hh6`,
	"red-100": `styles_red-100__Ahrgo`,
	"red-200": `styles_red-200__ny4hS`,
	"red-300": `styles_red-300__C-R35`,
	"red-400": `styles_red-400__hb2MM`,
	"red-500": `styles_red-500__Y7t+w`,
	"yellow-50": `styles_yellow-50__YvupQ`,
	"yellow-100": `styles_yellow-100__4htRX`,
	"yellow-200": `styles_yellow-200__NuhoI`,
	"yellow-300": `styles_yellow-300__ME-ll`,
	"yellow-400": `styles_yellow-400__6nqup`,
	"yellow-500": `styles_yellow-500__rc+8H`,
	"orange-50": `styles_orange-50__0+vKy`,
	"orange-100": `styles_orange-100__VAl3D`,
	"orange-200": `styles_orange-200__OO39N`,
	"orange-300": `styles_orange-300__Zk4V6`,
	"orange-400": `styles_orange-400__RSDi5`,
	"orange-500": `styles_orange-500__UFXJh`,
	"turquoise-50": `styles_turquoise-50__PDtAv`,
	"turquoise-100": `styles_turquoise-100__nAM0V`,
	"turquoise-200": `styles_turquoise-200__NpOqC`,
	"turquoise-300": `styles_turquoise-300__YuqYs`,
	"turquoise-400": `styles_turquoise-400__vedAS`,
	"turquoise-500": `styles_turquoise-500__+Zaob`,
	"turquoise-600": `styles_turquoise-600__aeLuI`,
	"violet-50": `styles_violet-50__7WaOX`,
	"violet-100": `styles_violet-100__FvAvU`,
	"violet-200": `styles_violet-200__3czXB`,
	"violet-300": `styles_violet-300__WyZKx`,
	"violet-400": `styles_violet-400__kvaSe`,
	"violet-500": `styles_violet-500__inRME`,
	"snow-50": `styles_snow-50__V8U6P`,
	"snow-100": `styles_snow-100__6yGx+`,
	"snow-200": `styles_snow-200__k5yzZ`,
	"snow-300": `styles_snow-300__FO+w0`,
	"snow-400": `styles_snow-400__0wG-2`,
	"snow-500": `styles_snow-500__xJ2SW`,
	"background-color": `styles_background-color__2Wpg8`,
	"ocean": `styles_ocean__mbn5t`,
	"ocean-light": `styles_ocean-light__GEXxl`,
	"green": `styles_green__2vqsm`,
	"green-light": `styles_green-light__q-PH-`,
	"red": `styles_red__yarrS`,
	"red-light": `styles_red-light__-0sva`,
	"orange": `styles_orange__dhVVm`,
	"orange-light": `styles_orange-light__6WwNY`,
	"space": `styles_space__Of7Am`,
	"space-light": `styles_space-light__Z2btQ`,
	"gray-light": `styles_gray-light__cjMSv`,
	"violet": `styles_violet__keC1U`,
	"violet-light": `styles_violet-light__pXJDN`,
	"yellow": `styles_yellow__R9Jgr`,
	"yellow-light": `styles_yellow-light__JrR13`,
	"root": `styles_root__DhE8V`,
	"roomWrapper": `styles_roomWrapper__wCPLg`,
	"current": `styles_current__-fDkU`,
	"roomAvatarWrapper": `styles_roomAvatarWrapper__0PB3p`,
	"roomTitle": `styles_roomTitle__PZb9O`,
	"roomLastMessage": `styles_roomLastMessage__GOcbg`,
	"roomMetadataWrapper": `styles_roomMetadataWrapper__EktY7`,
	"unreadMessagesCount": `styles_unreadMessagesCount__LNPzI`,
	"groupRoomIcon": `styles_groupRoomIcon__jRj+1`,
	"fab": `styles_fab__PHhYj`,
	"fabArrow": `styles_fabArrow__T3B9j`
};
export default ___CSS_LOADER_EXPORT___;
